import { render, staticRenderFns } from "./AuthorizeSuccessful.vue?vue&type=template&id=5f72988f&scoped=true"
import script from "./AuthorizeSuccessful.vue?vue&type=script&lang=js"
export * from "./AuthorizeSuccessful.vue?vue&type=script&lang=js"
import style0 from "./AuthorizeSuccessful.vue?vue&type=style&index=0&id=5f72988f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72988f",
  null
  
)

export default component.exports